import { render, staticRenderFns } from "./ListReports.vue?vue&type=template&id=707d853a&"
import script from "./ListReports.vue?vue&type=script&lang=js&"
export * from "./ListReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports